export const API_URL = process.env.API_URL;

export const post = (url: string, json: any = {}) => {
    const urlbody : string = new URLSearchParams(Object.entries(json)).toString();
    console.log(urlbody);

    return fetch(API_URL + url, {
        method: 'POST',
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'include', // include, *same-origin, omit
        headers: {
          // 'Content-Type': 'application/json'
          'Content-Type': "application/x-www-form-urlencoded"
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: urlbody // body data type must match "Content-Type" header
    })
}